import { Modal } from "react-bootstrap"

interface OtherPaymentMethodModalProps {
  show: boolean
  isLoading: boolean
  onClose: () => void
  onConfirm: () => void
}

export default function OtherPaymentMethodModal({ show, isLoading, onClose, onConfirm }: OtherPaymentMethodModalProps) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Altro metodo di pagamento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Dopo che il tuo ordine verrà confermato, ti preghiamo di contattare il supporto per completare il pagamento
          con altri metodi.
        </p>
        <p>
          Scrivi a: <a href="mailto:pagamenti@buonisulserio.it">pagamenti@buonisulserio.it</a>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-violet-outline" onClick={onClose} disabled={isLoading}>
          Annulla
        </button>
        {!isLoading ? (
          <button type="button" className="btn btn-violet" onClick={onConfirm}>
            Conferma
          </button>
        ) : (
          <button type="button" className="btn btn-violet" disabled>
            <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Caricamento...
          </button>
        )}
      </Modal.Footer>
    </Modal>
  )
}
